import { useState } from 'react';
import { downloadFromApi } from '@utils/download';
import { convertToRailsQueryString } from '@utils/api';
import { CpgReportsParams } from '@features/campaigns';
import { GetCampaignParams } from '@features/campaigns';
import { CpgLciReportDownloadContainer } from '@components/shared/Reports/CpgLciReportDownloadButton';
import { CpgExecutiveReportDownload } from '@components/shared/Reports/CpgExecutiveReportDownload';
import {
  BaseDownloadModal,
  BaseDownloadModalProps,
} from '@features/reports/components/BaseDownloadModal';

type DownloadModalProps = {
  campaignName: string;
  campaignId: number;
  reportId: number;
  renderOpener: BaseDownloadModalProps['renderOpener'];
  campaignParams: GetCampaignParams;
  channel: string | null;
};

export const DownloadModal = (props: DownloadModalProps) => {
  const {
    campaignName,
    campaignId,
    reportId,
    renderOpener,
    campaignParams,
    channel,
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  const reportParams: Omit<CpgReportsParams, 'campaignId'> = {
    includeUnapproved: campaignParams.include_unapproved ?? false,
    showRestrictedValues: false,
    channel,
  };

  const downloadSummaryReport = () => {
    downloadFromApi(
      `/api/v3/cpg/campaigns/${campaignId}/reports/${reportId}/summary_file?${convertToRailsQueryString(reportParams)}`
    );
  };

  const downloadFlatReport = () => {
    downloadFromApi(
      `/api/v3/cpg/campaigns/${campaignId}/reports/${reportId}/flat_file?${convertToRailsQueryString(reportParams)}`
    );
  };

  return (
    <BaseDownloadModal
      campaignId={campaignId}
      campaignName={campaignName}
      renderOpener={renderOpener}
      isOpen={isOpen}
      onOpenerClick={() => setIsOpen(true)}
      onCloserClick={() => setIsOpen(false)}
      downloadOptions={[
        {
          name: 'summary',
          group: 'Data Output',
          label: 'Summary (.xlsx)',
          onClick: downloadSummaryReport,
        },
        {
          name: 'flat',
          group: 'Data Output',
          label: 'Standard (.csv)',
          onClick: downloadFlatReport,
        },
        {
          name: 'lciReport',
          group: 'Presentation',
          component: (
            <CpgLciReportDownloadContainer
              campaignId={campaignId}
              reportParams={reportParams}
              campaignParams={campaignParams}
            />
          ),
        },
        {
          name: 'executiveReport',
          group: 'Presentation',
          component: (
            <CpgExecutiveReportDownload
              campaignId={campaignId}
              reportParams={reportParams}
              campaignParams={campaignParams}
            />
          ),
        },
      ]}
    />
  );
};
